import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "./ui/card";
import { CheckCircle2, Clock, AlertTriangle, ChevronRight } from "lucide-react";

const fmtData = (iso) => {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
  } catch { return iso; }
};

// Mapeamento etapa do funil → aba do LeadDetalhe
const ETAPA_TO_TAB = {
  proposta: "propostas",
  analise: "propostas",
  contrato: "pedidos",
  efetivado: "pedidos",
  contato: "conversas",
  visita: "conversas",
  lead: "dados",
};

export default function FunilTimeline({ leadId, onNavigate }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/leads/${leadId}/timeline`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [leadId]);

  if (!data) return <div className="text-sm text-muted-foreground py-4">Carregando linha do tempo…</div>;

  return (
    <Card className="p-5" data-testid="funil-timeline">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-base font-bold" style={{ color: "#1B3A6B" }}>Linha do Tempo do Funil</h3>
        {data.alerta_parado && (
          <span className="flex items-center gap-1 text-xs font-medium" style={{ color: "#ca8a04" }} data-testid="alerta-parado">
            <AlertTriangle size={14} /> Parado há {data.dias_parado} dias na etapa <strong>{data.status_label}</strong>
          </span>
        )}
      </div>
      <div className="space-y-1">
        {data.timeline.map((t, idx) => {
          const tabAlvo = ETAPA_TO_TAB[t.etapa];
          const clicavel = !!(tabAlvo && onNavigate);
          return (
            <div
              key={t.etapa}
              className={`flex items-center gap-3 py-2 ${t.atual ? "bg-blue-50 -mx-2 px-2 rounded" : ""} ${clicavel ? "cursor-pointer hover:bg-slate-50 rounded -mx-2 px-2 transition" : ""}`}
              data-testid={`timeline-${t.etapa}`}
              onClick={clicavel ? () => onNavigate(tabAlvo) : undefined}
              title={clicavel ? `Abrir aba ${tabAlvo}` : undefined}
              role={clicavel ? "button" : undefined}
            >
              <div className="flex-shrink-0">
                {t.atingida ? (
                  <CheckCircle2 size={20} style={{ color: t.atual ? "#1B3A6B" : "#16a34a" }} />
                ) : (
                  <Clock size={20} className="text-zinc-400" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className={`text-sm ${t.atingida ? "font-medium" : "text-zinc-500"}`}>
                  {idx + 1}. {t.label}
                  {t.atual && <span className="ml-2 text-xs text-blue-700">(etapa atual)</span>}
                </div>
              </div>
              <div className="text-xs text-muted-foreground">
                {t.atingida ? fmtData(t.data) : "aguardando"}
              </div>
              {clicavel && <ChevronRight size={14} className="text-muted-foreground" />}
            </div>
          );
        })}
      </div>
      {onNavigate && (
        <div className="text-[11px] text-muted-foreground mt-3 italic">
          Dica: clique em qualquer etapa atingida para abrir os detalhes correspondentes.
        </div>
      )}
    </Card>
  );
}
